import React, {useEffect, useState} from "react";
import { useDispatch, useSelector } from "react-redux";
import { FaPlus, FaEdit } from "react-icons/fa";
import UserFormModal from "./UserFormModal";
import ResetPasswordModal from "./ResetPasswordModal";
import { fetchUsers, resetUserPassword, toggleUserActive, saveUser } from "../../../ReduxSlices/Admin/userSlice";
import {  addUserOptimistic, removeUser, replaceUser } from "../../../ReduxSlices/Admin/userSlice";
import LoadingDots from "../../shared/LoadingDots";

const ROLE_LABELS = {
  receptionist: "Receptionist",
  doctor: "Doctor",
  lab_technician: "Lab Technician",
  pharmacist: "Pharmacist",
  admin: "Admin",
};

const formatDate = (dateString) => {
  const date = new Date(dateString);
  return date.toLocaleString("en-KE", {
    day: "2-digit",
    month: "short",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });
};

const UserList = () => {
    const dispatch = useDispatch();
    const users  = useSelector((state) => state.users.list);
    const loading = useSelector((state) => state.users.loading);
    const [showModal, setShowModal] = useState(false);
    const [showResetModal, setShowResetModal] = useState(false);
    const [userToReset, setUserToReset] = useState(null);
    const [editingUser, setEditingUser] = useState(null);
    

  useEffect(() => {
  if (!users || users.length === 0) {
    dispatch(fetchUsers());
  }
}, [dispatch, users]);

    
const handleSave = async (formData) => {
  const id = editingUser?.id;   // freeze immediately
  const isEditing = !!id;

  let tempId;

  if (isEditing) {
    dispatch(
      replaceUser({
        tempId: id,
        user: { ...editingUser, ...formData },
      })
    );
  } else {
    tempId = `temp-${Date.now()}`;
    dispatch(addUserOptimistic({ ...formData, id: tempId }));
  }

  setShowModal(false);

  try {
    const res = await dispatch(
      saveUser({ id, data: formData, tempId })
    ).unwrap();

    dispatch(
      replaceUser({
        tempId: isEditing ? id : tempId,
        user: res.savedUser,
      })
    );

  setEditingUser(null);
  } catch (error) {
    if (!isEditing) dispatch(removeUser(tempId));
  }
};

const openCreateModal = () => {
  setEditingUser(null);
  setShowModal(true);
};

const openEditModal = (user) => {
  setEditingUser(user);
  setShowModal(true);
};

const closeModal = () => {
  setShowModal(false);
  setEditingUser(null);
};

const closeResetModal = () => {
  setShowResetModal(false);
  setUserToReset(null);
};

  const handleToggleActive = (user) => {
    const action = user.active ? "deactivate" : "activate";
      dispatch(toggleUserActive(user));
  };

    const handleResetPassword = async (id, formData) => {
    const res = await dispatch(resetUserPassword({ id, data: formData }));
    if (!res.error) {
      } else {
      alert(res.error.message || "Failed to reset password");
    }
  };


    if (loading) return (<LoadingDots height={10} width={30} color="#38AD3E" />);


    return (
        <div className="p-4">
            <div className="flex justify-between items-center mb-4">
                <h2 className="text-xl font-semibold">All Users</h2>
                <button className="primary extra-wide flex gap-[10px]" 
                type="button"
                onClick={openCreateModal}
                >
                    <FaPlus />  Add User
                </button>
            </div>

        <table className="min-w-full border">
            <thead className="bg-gray-100">
                <tr>
                    <th className="p-2 border">Name</th>
                    <th className="p-2 border">Email</th>
                    <th className="p-2 border">Role</th>
                    <th className="p-2 border">Last Logged In</th> 
                    <th className="p-2 border">Status</th>
                    <th className="p-2 border">Actions</th>
                </tr>
            </thead>

            <tbody>
                {users.map((user) =>(
                    <tr key={user.id} className="lighten">
                        <td className="p-2 border">{user.name}</td>
                        <td className="p-2 border">{user.email}</td>
                        <td className="p-2 border capitalize">{ROLE_LABELS[user.role] || user.role}</td>
                        <td className="p-2 border">
                        {user.last_sign_in_at
                        ? formatDate(user.last_sign_in_at)
                        : "—"}
                        </td>
                        <td className="p-2 border">{user.active ? "🟢 Active" : "🔴 Inactive"}</td>

                        <td className="p-2 border flex gap-[10px]">
                            <button 
                            onClick={() => {
                                openEditModal(user);
                            }}
                            className="flex items-center gap-1">
                            <FaEdit /> Edit
                            </button>
                            <button
                                className="flex items-center gap-1 text-blue-600"
                                onClick={() => {
                                    setUserToReset(user);
                                    setShowResetModal(true);
                                }}
                                >
                                🔑 Reset Password
                                </button>

                           <button
                            onClick={() => handleToggleActive(user)}
                            className={`flex items-center gap-1 ${
                                user.active ? "secondary" : "primary"
                            }`}
                            >
                            {user.active ? "🛑 Deactivate" : " Activate "}
                            </button>


                        </td>
                    </tr>
                ))}
            </tbody>
        </table>

        <UserFormModal
            show={showModal}
            onclose={closeModal}                              
            onSave={handleSave}
            user={editingUser}
        />

        <ResetPasswordModal
        show={showResetModal}
        onClose={closeResetModal}
        user={userToReset}
        onReset={handleResetPassword}
        />

        </div>
    );
};

export default UserList;